import TUIChat from './TUIChat';
import TUIConversation from './TUIConversation';
import TUIGroup from './TUIGroup';
import TUIContact from './TUIContact';
import TUISearch from './TUISearch';

import message from './message';
import component from './component';
import time from './time';

import Words from './words';
import Evaluate from './evaluate';
import Emoji from './emoji';

const messages = {
  zh_tw: {
    取消: '取消',
    发送: '發送',
    系统通知: '系統通知',
    关闭: '關閉',
    确定: '確定',
    开始时间: '開始時間',
    结束时间: '結束時間',
    消息: '消息',
    通讯录: '通訊錄',
    欢迎使用腾讯云即时通信IM: '歡迎使用騰訊雲即時通信IM',
    TUIChat,
    TUIConversation,
    TUIGroup,
    TUIContact,
    message,
    component,
    time,
    Evaluate,
    Words,
    TUISearch,
    Emoji,
  },
};

export default messages;
